import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import moment from "moment";
import "datatables.net";
import "datatables.net-buttons";
import "datatables.net-select";
import "datatables.net-bs";
import "datatables.net-buttons-bs";
import "datatables.net-rowgroup";
import "datatables.net-rowgroup-bs";

// $.extend(true, $.fn.DataTable.TableTools.classes, {
//     "container" : "btn-group btn-group-sm",
//     "buttons" : {
//         "normal" : "btn",
//         "disabled" : "disabled hidden"
//     }
// });
// $.extend($.fn.DataTable.ext.classes, {
//     sFilter:"form-group pull-right filter-form"
// });


uly.formatters = {
    "percent": function(data,type,row) {
        if(data){
            if (type === 'display') {
                if (data < 50) {
                    return "<span style='color:red;font-weight:bold;'>" + data + "%</span>";
                } else {
                    return "<span style='color:green'>" + data + "%</span>";
                }
            }else if (type === 'filter') {
                return data + "%";
            }
        }
        return "-";
    },
    "percentbar": function(data,type,row) {

        if(data){
            if (type === 'display') {

                var color;

                if (data < 30) {
                    color = "red";
                } else if (data < 70) {
                    color = "silver";
                } else {
                    color = "green";
                }

                return "<span class='percent-complete-bar' style='background:" + color + ";width:" + data + "%'></span>";
            }
            return data;
        }
        return "";
    },
    "checkbox": function(data,type,row) {
        if(data !== null && data !== undefined){
            if (type === 'display' || type === 'filter') {
                if (data == "true" || data === true)
                    return '<div class="grid-check"><span class="ui-icon fa fa-check-square-o"></span></div>';
                else
                    return '<div class="grid-check"><span class="ui-icon fa fa-square-o"></span></div>';
            }
            return data;
        }
        return data;
    },
    "icon": function(data,type,row){
        if(data){
            if (type === 'display') {
                if (data && row.colour) {
                    return '<i class="fa '+data+' text-'+row.colour+'" ></i>';
                }
                else return '<i class="fa '+data+'" ></i>';
            }
        }
        return "";
    },
    "date":function(data,type,row){
        if (data && data.typeof("String")) {
            data = new Date(data);
        }
        if(data && data.typeof("Date")){
            if (type === 'display' || type === 'filter') {
                return new moment(data).format("L");
            }
            return data.getTime();
        }
        return data;
    },
    "datetime":function(data,type,row){
        if (data && data.typeof("String")) {
            data = new Date(data);
        }
        if(data && data.typeof("Date")){
            if (type === 'display' || type === 'filter') {
                return new moment(data).format("L LT");
            }
            return data.getTime();
        }
        return data;
    },
    "longdate":function(data,type,row){
        if(data && data.typeof("Date")){
            if (type === 'display' || type === 'filter') {
                return new moment(data).format("LL");
            }
            return data.getTime();
        }
        return data;
    },
    "time":function(data,type,row){
        if(data && data.typeof("Date")){
            if (type === 'display' || type === 'filter') {
                return new moment(data).format("LT");
            }
            return data.getTime();
        }
        return data;

    },
    "text":function(data, type, row){
        if (Object.isObject(data) && data.__class__ && uly.formatters[data.__class__]) {
            return uly.formatters[data.__class__](data, type, row);
        }
        return data;
    },
    "richtext":function(data, type, row) {
        if(data){
            if (Object.isObject(data)) {
                if (data.name)
                    data = data.name;
                else if (data.title)
                    data = data.title;
                else
                    data = null;
            }
            return uly.utils.decode_html_entities(data);
        }
        return data;
    },
    "currency":function(data, type, row) {
        if(data){
            if (type === 'display' || type === 'filter') {
                return Globalize.format(data, "c");
            }
            return data;
        }
        return data;
    },
    "number":function(data,type,row) {
        if(data){
            if (type === 'display' || type === 'filter') {
                return Globalize.format(data, "n");
            }
            return data;
        }
        return data;
    }
};

function fetch_grid_buttons(grid) {
    var hal_grid = HalResource(grid);
    var select_p = hal_grid.follow("uly:selectactions"),
        edit_p = hal_grid.follow("uly:editactions"),
        add_p = hal_grid.follow("uly:addactions");

        return Promise.whenAll(
            select_p,
            edit_p,
            add_p
        ).then(function([selectactions, editactions, addactions]) {
            function flatten (actionset) {
                if (typeof actionset == "undefined" || !actionset) {
                    return {};
                }
                
                if (typeof actionset.forEach == "undefined") {
                    actionset = [actionset];
                }

                var tmp = {};
                $.each(
                    uly.actions.classifyActions(actionset),
                    function(set, actions) {
                        $.each(actions, function(idx,action) {
                            tmp[action.name] = action;
                        });
                    });
                return tmp;
            }
            var button_sets = {
                edit: flatten(editactions),
                select: flatten(selectactions),
                add: flatten(addactions)
            };
            return button_sets;
        }, function(e) { 
            console.error("Error fetching buttons:", e);
            return { edit: {}, select: {}, add: {} };
        });
}

function compute_buttons_list(grid) {
    var buttons = [];
    $.each(grid.select, function(key, button) {
        buttons.push({
            "extend": "selected",
            "text": "<i class='fa " + (button.icon || 'fa-caret-square-o-right') + "'></i> <span class='hidden-xs-unblock hidden-sm-unblock'> " + button.caption + '</span>',
            "className": "btn btn-md btn-default " + (button.colour ? "text-" + button.colour : ""),
            "init": function(dt, btn, config) {
                //$(btn).addClass( dt.classes.buttons.disabled );
                var that = this;

                dt.on( 'select.dt.DT deselect.dt.DT', function () {
                    var enabled = dt.rows( { selected: true } ).any();
                    that.enable( enabled );
                    if (enabled) { 
                        btn.removeClass("hidden");
                    } else {
                        btn.addClass("hidden");
                    }

                } );

                this.disable();              
                btn.addClass("hidden");                      
            },
            "action": function(ev, datatable, elt, config) {
                var ui = {};
                ui.model = button;
                ui.entity_model = [];
                var rows = datatable.rows({selected:true}).data();
                for (var i=0; i<rows.length; i++)
                    ui.entity_model.push(rows[i]);
                $(elt).trigger("action:" + key, ui);
                ev.preventDefault();
            },
            "fnSelect": function( nButton, oConfig ) {
                if ( this.fnGetSelected().length !== 0 ) {
                $(nButton).removeClass( this.classes.buttons.disabled );
                } else {
                    $(nButton).addClass( this.classes.buttons.disabled );
                }
            }
        });
    });
    $.each(grid.add, function(key, button) {
        buttons.push({
            //"extend": "text",
            "sAction": "text",
            "text": "<i class='fa " + (button.icon || 'fa-caret-square-o-right') + "'></i> <span class='hidden-xs-unblock hidden-sm-unblock'> " + button.caption + '</span>',
            "className": "btn btn-md btn-default " + (button.colour ? "text-" + button.colour : ""),
            "fnInit": function(btn, config) {
                $(btn).removeClass( this.classes.buttons.disabled );
            },
            "action": function(ev, datatable, elt, config) {
                var data = { "context": ko.contextFor($(elt)[0]) };
                $(elt).trigger("action:"+key, data);
                ev.preventDefault();
            }
        });
    });
    
    return buttons;

}

ko.bindingHandlers.datatable = {
    "init":function(elt, va, allbindings, model, context) {
        var result = va.typeof("Function") ? ko.toJS(va()) : va;
        var hal = HalResource(result);
        var click_action_override = ko.unwrap(allbindings().click_action);
        var options = ko.unwrap(allbindings().grid_options) || {};
        hal.get_uri().done(function(uri){
            hal.follow("uly:grid").done(function(grid){
                grid.id = result.id;
                grid.uri = uri;
                fetch_grid_buttons(grid).always((button_sets) => {
                    Object.assign(grid, button_sets);
                    var buttons = ko.unwrap(grid.show_buttons) !== false ? compute_buttons_list(grid) : [];
                    var $elt = $(elt);
                    ko.renderTemplate("detail-table-tmpl", grid, {}, elt, 'replaceChildren');
                    if (grid.data_columns)
                        grid.data_columns.unshift({data: null,defaultContent:'',orderable: false});
                    else grid.data_columns = [{data: null,defaultContent:'',orderable: false}];

                    $(grid.data_columns).each(function(idx){
                        this["render"] = uly.formatters[this["formatter"]];
                    });

                    var table = $elt.find("table");

                    var dataparameters = ko.toJS(allbindings().dataparameters || {});
                    var data_obs = ko.observableArray([]);
                    var table_config = Object.assign({
                        responsive: true,
                        select: grid.select || "multiple",
                        buttons: {
                            buttons: buttons,
                            dom: {
                                buttonContainer: "btn-group btn-group-sm"
                            }
                        },
                        ajax:function(data, callback, settings) {
                            callback({"data":data_obs()});
                            //Force recalculation of button visibility
                            if (datatable) {
                               // TableTools._fnEventDispatch(datatable.tabletools(), 'select', null, null);
                            }
                        },
                        columns: grid.data_columns,
                        deferRender: true,
                        dom: '<"row"<"col col-sm-6"Bl><"col col-sm-6 pull-right"f>>'+
                            //"<'row'<'col-sm-6'l><'col-sm-6'f>>" +
                            "<'row'<'col-sm-12'<'scrolly'tr>>>" +
                            "<'row'<'col-sm-5'i><'col-sm-7'p>>",
                        info: true,
                        paging: false,
                        searching: true
                    }, options);

                    if (grid.group_by && grid.group_by != "") {
                        table_config.rowGroup = {
                            dataSrc: grid.group_by,
                            emptyDataGroup: _("datatables_empty_group", "Misc")
                        }
                    }

                    var datatable = table.DataTable(table_config);
                    data_obs.subscribe(function(newvalue) {
                        datatable.ajax.reload();
                    });

                    $.data(elt, "datatable", datatable);

                    table.on( 'click', 'tbody tr', function (e) {
                        //table.find(".selected").removeClass("selected");
                        if ($(e.target).index() != 0){
                            //$(this).addClass("selected");
                            var row = datatable.row(this).data(), edit = null;
                            if (row && grid.edit && row.edit){
                                if (row.edit in grid.edit){
                                    edit = grid.edit[row.edit];
                                }
                            }
                            var fake_ui = {};fake_ui.model = edit;fake_ui.entity_model = row;
                            if (click_action_override) {
                                if (typeof click_action_override == "function") click_action_override(e, $(elt), fake_ui);
                                else $(document).trigger(click_action_override,[fake_ui]);
                            }
                            else if (edit) {
                                $(document).trigger("action:"+edit.name,[fake_ui]);
                            }
                        }
                    });

                    var refresh = function() {
                        hal.follow("uly:datatable", dataparameters ).done(function(table_data) {
                            data_obs(table_data.data);
                        });
                    };
                    //initial refresh
                    refresh();
                    uly.subscribe("entity.modified", refresh, $(elt));
                });
            });
        });
    }
};
